import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, DoCheck, HostListener, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { GameLaunchService } from '@frontend/bingo/frontend-lib/core';
//import { DOCUMENT, SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { CommonMessages, CookieService, MessageQueueService, TrackingService } from '@frontend/vanilla/core';
import { BalancePropertiesService } from '@frontend/vanilla/features/balance-properties';
import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';

@Component({
    selector: 'bg-embedded-game-view',
    templateUrl: 'embedded-game-view.component.html',
    imports: [CommonModule, MessagePanelComponent],
})
export class EmbeddedGameViewComponent implements OnInit, DoCheck {
    value: string;
    Game: any;
    isIframeVisible: boolean = false;
    isGreaterthan: boolean = false;
    iframe: any;
    isFullScreen: boolean = false;
    mobHeight: any;
    mobWidth: any;
    isLiveDealerOpen: any;
    date: Date;
    innerWidth: any;
    iframeUrl: SafeResourceUrl;
    iconShrinkClickedFirst: boolean = false;
    embededPopUpWidth: any;
    embededPopUpHeight: any;
    gameLaunchSuccess: boolean;
    commonMessages: any;
    isLoaderHide: boolean;
    isTouch: boolean;
    Global: any;
    constructor(
        @Inject(DOCUMENT) private document: any,
        //@Inject('LiveDealer') LiveDealer: any,
        private messageQueue: MessageQueueService,
        // private dialog: MatDialog,
        private balanceService: BalancePropertiesService,
        private cookie: CookieService,
        // private navigationService: NavigationService,
        private tracking: TrackingService,
        // private location: Location,
        private gameLaunchService: GameLaunchService,
        private commonMessagesObject: CommonMessages,
        private sanitizer: DomSanitizer,
        private activeRoute: ActivatedRoute,
        // private m2Page: Page,
        // private route: ActivatedRoute,
        // private productHomepagesConfig: ProductHomepagesConfig
    ) {
        this.gameLaunchService.gameDataObject.subscribe((gameData: any) => {
            this.Game = gameData;
            // this.setGameTitle();
            // let lmtGameMetaData: any = this.gameDataManager.getLMTGameData(gameData.gameId);
            // console.log('lmtGameMetaData: ' + JSON.stringify(lmtGameMetaData));
            // if (lmtGameMetaData) {
            this.Game.title = gameData.name;
            // }
            document.body.classList.add('embed-hide-scroll');
        });
    }

    ngOnInit() {
        //let referrer = document.referrer;

        // if((referrer && referrer.length > 0) && !(this.casinoManager.getGameHomeUrl() && this.casinoManager.getGameHomeUrl().length > 0)){
        //     this.casinoManager.setGameHomeUrl(referrer);
        // }
        this.Global = this.activeRoute.snapshot.data['config'].global;
        this.messageQueue.clear({ clearPersistent: true });
        this.commonMessages = this.commonMessagesObject;

        this.innerWidth = window.screen.width;
        this.isLoaderHide = false;
        //this.catgeoryDataClientConfig = this.categoryData;
        document.getElementById('myModal')!.style.height = window.screen.height + 'px';
        //document.getElementsByTagName('html')[0].style.overflow='hidden';
        this.gameLaunchSuccess = true;
        if (this.getFromCookie('gameLaunchedCount')) {
            this.gameLaunchSuccess = false;
            const message = this.Global.messages.OnlyOneGameAtTime;
            this.messageQueue.addError(message);
        } else {
            if (this.Game?.url) {
                this.launchGameInEmbedIFrame();
            }
        }
        this.date = new Date();
    }

    launchGameInEmbedIFrame() {
        this.embededPopUpWidth = this.GetParam('width', this.Game.url);
        this.embededPopUpHeight = this.GetParam('height', this.Game.url);
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.Game.url);
        this.setToCookie('gameLaunchedCount', '1');
    }

    setToCookie(key: any, value: any) {
        this.cookie.put(key, value);
    }
    getFromCookie(key: any): boolean {
        if (this.cookie.get(key) === '1') {
            return true;
        }
        return false;
    }
    GetParam(name: any, url: any) {
        const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
        if (!results) {
            return 0;
        }
        return results[1] || 0;
    }

    handleScreenChange(event: any) {
        document.getElementById('myModal')!.style.height = window.screen.height + 'px';
        event.stopImmediatePropagation();
    }

    @HostListener('window:message', ['$event']) closeOnRCPUClose(event: any) {
        if (event.data === 'CASINO_GAME_CLOSED' || event.data === 'CASINO_GAME_EXIT') {
            this.close(false);
        }
    }

    @HostListener('window:unload', [])
    unloadHandler() {
        this.cookie.remove('gameLaunchedCount');
    }

    @HostListener('document:fullscreenchange', ['$event']) fullscreenchangeHandler(event: KeyboardEvent) {
        this.isFullScreen = (document as any).webkitIsFullScreen;
        this.handleScreenChange(event);
    }
    @HostListener('document:webkitfullscreenchange', ['$event']) webkitfullscreenchangeHandler(event: KeyboardEvent) {
        this.isFullScreen = (document as any).webkitIsFullScreen;
        this.handleScreenChange(event);
    }
    @HostListener('document:mozfullscreenchange', ['$event']) mozfullscreenchangeHandler(event: KeyboardEvent) {
        const doc: any = document;
        this.isFullScreen = doc.mozFullScreen;
        this.handleScreenChange(event);
    }
    @HostListener('document:MSFullscreenChange', ['$event']) MSFullscreenChangeHandler(event: KeyboardEvent) {
        this.isFullScreen = (document as any).webkitIsFullScreen;
        this.handleScreenChange(event);
    }

    ngDoCheck() {
        this.date = new Date();
    }
    close(fromEmbedded: boolean) {
        //let launchCategory = this.route.snapshot.queryParamMap.get('launchCategory');
        //let nav = this.Navigator;
        this.messageQueue.clear({ clearPersistent: true });
        if (fromEmbedded) {
            this.cookie.remove('gameLaunchedCount');
        }
        this.balanceService.refresh();
        // As per Zlatko, this should be removed Vanilla 8 onwards.
        const iframe = document.getElementById('embedGameIframe') as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage('PREVIOUS_CASINO_GAME_CLOSED', '*');
        }
        setTimeout(() => {
            document.body.classList.remove('embed-hide-scroll');

            this.gameLaunchService.setOverlayVisibility(false);

            this.innerWidth = window.screen.width;

            // if (gameHomeUrl && gameHomeUrl != '') {
            //     this.casinoManager.setGameHomeUrl('');
            //     this.navigationService.goTo(gameHomeUrl);
            // }

            // if (this.location.path().indexOf('forcedEmbeddedLaunch') > -1) {
            //     this.navigationService.goTo('/' + this.m2Page.lang + '/' + this.casinoManager.getProductForLobbyType().toLowerCase());
            // }
        }, 500);
    }

    // openNav() {
    //     this.isIframeVisible = true;
    //     this.isGreaterthan = true;
    //     document.getElementById('mySidenav').style.width = '100%';
    //     document.getElementById('mySidenav').style.position = 'fixed';
    // }
    // closeNav() {
    //     this.isIframeVisible = false;
    //     this.isGreaterthan = false;
    //     document.getElementById('mySidenav').style.width = '100%';
    //     document.getElementById('mySidenav').style.position = 'inherit';
    // }
    fullScreen() {
        if (this.checkFullScreen()) {
            this.adjustGamesPanel();
            this.requestFullScreen();
        } else {
            this.minimizeFullScreen();
        }
    }

    minimizeFullScreen() {
        this.isIframeVisible = false;
        document.getElementById('mySidenav')!.style.width = '100%';
        document.getElementById('mySidenav')!.style.position = 'inherit';
        this.isFullScreen = false;
        if (this.document.cancelFullScreen) {
            this.document.cancelFullScreen();
        } else if (this.document.mozCancelFullScreen) {
            this.document.mozCancelFullScreen();
        } else if (this.document.webkitCancelFullScreen) {
            this.document.webkitCancelFullScreen();
        } else if (this.document.msExitFullscreen) {
            this.document.msExitFullscreen();
        }
    }

    adjustGamesPanel() {
        document.getElementById('mySidenav')!.style.width = '100%';
        document.getElementById('mySidenav')!.style.position = 'fixed';
        this.isIframeVisible = true;
        this.isFullScreen = true;
        if (this.isFullScreen) {
            this.isGreaterthan = false;
        }
    }

    checkFullScreen(): boolean {
        return (
            (this.document.fullScreenElement !== undefined && this.document.fullScreenElement === null) ||
            (this.document.msFullscreenElement !== undefined && this.document.msFullscreenElement === null) ||
            (this.document.mozFullScreen !== undefined && !this.document.mozFullScreen) ||
            (this.document.webkitIsFullScreen !== undefined && !this.document.webkitIsFullScreen)
        );
    }

    requestFullScreen() {
        if (this.document.body.requestFullScreen) {
            this.document.body.requestFullScreen();
        } else if (this.document.body.mozRequestFullScreen) {
            this.document.body.mozRequestFullScreen();
        } else if (this.document.body.webkitRequestFullScreen) {
            this.document.querySelector('body').webkitRequestFullScreen();
        } else if (this.document.body.msRequestFullscreen) {
            this.document.body.msRequestFullscreen();
        }
    }

    toggleFullWindowScreen() {
        if (!(document as any).webkitIsFullScreen) {
            this.allowFullScreen();
        } else {
            this.cancelFullScreen();
        }
    }

    allowFullScreen() {
        const doc: any = document;
        if (this.document.body.requestFullScreen) {
            this.document.body.requestFullScreen();
        } else if (doc.body.mozRequestFullScreen) {
            const docElm: any = document.documentElement;
            docElm.mozRequestFullScreen();
        } else if (this.document.body.webkitRequestFullScreen) {
            this.document.querySelector('body').webkitRequestFullScreen();
        } else if (this.document.body.msRequestFullscreen) {
            this.document.body.msRequestFullscreen();
        }
    }
    cancelFullScreen() {
        if (this.document.cancelFullScreen) {
            this.document.cancelFullScreen();
        } else if (this.document.mozCancelFullScreen) {
            this.document.mozCancelFullScreen();
        } else if (this.document.webkitCancelFullScreen) {
            this.document.webkitCancelFullScreen();
        } else if (this.document.msExitFullscreen) {
            this.document.msExitFullscreen();
        }
    }

    toggleFullScreen(event: any) {
        this.tracking.triggerEvent('GameInteraction', {
            'component.Game.interaction': 'EGV_PlayGame_FullScreen',
        });

        // if (this.isFullScreen) {
        //     document.getElementsByClassName('embed-left-section')[0].setAttribute('style', 'width:100%');
        // }
        // else if (!this.isFullScreen && this.extrasColumnFlag) {
        //     document.getElementsByClassName('embed-left-section')[0].setAttribute('style', 'width:100%');
        // }
        // else {
        //     document.getElementsByClassName('embed-left-section')[0].setAttribute('style', 'width:100%');
        // }

        if (
            (this.document.fullScreenElement !== undefined && this.document.fullScreenElement === null) ||
            (this.document.msFullscreenElement !== undefined && this.document.msFullscreenElement === null) ||
            (this.document.mozFullScreen !== undefined && !this.document.mozFullScreen) ||
            (this.document.webkitIsFullScreen !== undefined && !this.document.webkitIsFullScreen)
        ) {
            this.iconShrinkClickedFirst = false;
            if (this.document.body.requestFullScreen) {
                this.document.body.requestFullScreen();
            } else if (this.document.body.mozRequestFullScreen) {
                this.document.body.mozRequestFullScreen();
            } else if (this.document.body.webkitRequestFullScreen) {
                this.document.querySelector('body').webkitRequestFullScreen();
            } else if (this.document.body.msRequestFullscreen) {
                this.document.body.msRequestFullscreen();
            }
            document.getElementById('myModal')!.style.height = window.screen.height + 'px';
        } else {
            if (event.target.className === 'icon-shrink') {
                this.iconShrinkClickedFirst = true;
            }

            if (this.document.cancelFullScreen) {
                this.document.cancelFullScreen();
            } else if (this.document.mozCancelFullScreen) {
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitCancelFullScreen) {
                this.document.webkitCancelFullScreen();
            } else if (this.document.msExitFullscreen) {
                this.document.msExitFullscreen();
            }
            document.getElementById('myModal')!.style.height = window.screen.height + 'px';
        }
    }

    // toggleExtrasColumn() {
    //     this.extrasColumnFlag = !this.extrasColumnFlag;
    //     if (this.extrasColumnFlag) {
    //         document.getElementsByClassName('embed-left-section')[0].setAttribute('style', 'width:100%');
    //     }
    //     else {
    //         document.getElementsByClassName('embed-left-section')[0].setAttribute('style', 'width:100%');
    //     }
    // }

    // getGameLunchType(gameId: any) {
    //     let gameMetaData = this.gameDataManager.getAllGamesFromLMT();
    //     var launchType: string;
    //     if (gameMetaData) {
    //         for (let i = 0; i < gameMetaData.length; i++) {
    //             if (gameMetaData[i].game == gameId) {
    //                 launchType = gameMetaData[i].provider;
    //                 break;
    //             }
    //         }
    //         return launchType;
    //     }

    //     return null;
    // }

    // openDialog(): void {
    //     let dialogRef = this.dialog.open(CashierIframeComponent, {
    //         width: '790px',
    //         data: { name: 'cashier' }
    //     });

    //     dialogRef.afterClosed().subscribe(() => {
    //         console.log('The dialog was closed');
    //     });
    // }
}
